import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Editor } from '@tinymce/tinymce-react';
// Importação do Router
import {Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { ButtonToolbar, Dropdown, MenuItem} from 'react-bootstrap';

import QuestionImages from './QuestionImages';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Loading from '../../Miscelania/Loading';
import Alerta from '../../Miscelania/Alerta';
import RequestApi from '../../Miscelania/RequestApi';

class QuestionsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.question_id,
      name: this.props.question_data.name,
      setting_difficulty_id: this.props.question_data.setting_difficulty_id,
      number: this.props.question_data.number,
      multiple_choice: this.props.question_data.multiple_choice,
      active: this.props.question_data.active,
      content: 0,
    };
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.editar = this.editar.bind(this);
  }

  // Handlers
  handleEditorChange(e) {
    var content = e.target.getContent();
    this.setState({content: content});
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined') {
      this.setState({
        id: newProps.question_id,
        name: newProps.question_data.name,
        setting_difficulty_id: newProps.question_data.setting_difficulty_id,
        number: newProps.question_data.number,
        active: newProps.question_data.active,
        multiple_choice: newProps.question_data.multiple_choice,
        content: newProps.question_data.content,
      });
    }
    if(Array.isArray(newProps.lista_dificuldades)) {
      this.setState({lista_dificuldades: newProps.lista_dificuldades});
    }
  }
  // Fetch salvando a edição
  editar(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      setting_difficulty_id: this.state.setting_difficulty_id,
      number: this.state.number,
      active: this.state.active,
      multiple_choice: this.state.multiple_choice,
      content: this.state.content,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.editar}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome da questão:</label>
          <input type="text" name="name" className="form-control" placeholder="Nome da questão" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Número da questão:</label>
          <input type="text" name="number" disabled="disabled" className="form-control" placeholder="Número da questão" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Dificuldade de questão:</label>
          <Select
            className="form-field-name"
            name="setting_difficulty_id"
            value={this.state.setting_difficulty_id}
            searchable={true}
            placeholder={'Selecionar questão'}
            onChange={this.handleSelectChange.bind(this, 'setting_difficulty_id')}
            options={this.state.lista_dificuldades}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Múltipla Escolha?</label>
          <Select
            className="form-field-name"
            name="multiple_choice"
            value={this.state.multiple_choice}
            searchable={true}
            placeholder={false}
            onChange={this.handleSelectChange.bind(this, 'multiple_choice')}
            options={[
              {value: 0, label: "Não"},
              {value: 1, label: "Sim"},
            ]}
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Ativa?</label>
          <Select
            className="form-field-name"
            name="active"
            value={this.state.active}
            searchable={true}
            placeholder={false}
            onChange={this.handleSelectChange.bind(this, 'active')}
            options={[
              {value: 0, label: "Não"},
              {value: 1, label: "Sim"},
            ]}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <QuestionImages question_id={this.state.id} handleAlert={this.props.handleAlert} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <label>Enunciado da questão:</label>
          {(this.state.content !== 0 && typeof this.state.content != 'undefined') ? (
            <Editor
              initialValue={this.state.content}
              init={{
                plugins: 'link image code',
                toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
                language_url: config.get('cdn') + '/js/pt_BR.js',
                height: '300px',
              }}
              onChange={this.handleEditorChange}
            />          
            ): ""}
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default QuestionsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Questions/Elements/QuestionsEditTab.js